export default () => {
  const $topButton = $('.x-to-top')

  $(window).on('scroll', function () {
    let scrollTop = $(window).scrollTop()

    if (scrollTop > 180) {
      $topButton.addClass('is-shown')
    } else {
      $topButton.removeClass('is-shown')
    }
  })

  $topButton.on('click', function () {
    $('html,body').animate({
      scrollTop: 0
    }, 900)
  })
}